<template>
  <div class="charts-panel">
    <!-- Première ligne : Récoltes et Contrôles -->
    <!-- Deuxième ligne : Cultures et Certification -->
    <!-- Troisième ligne : Répartition géo et Performance antennes -->
    <el-tabs v-model="activeTab" type="card">
      <el-tab-pane label="Récoltes" name="recoltes">
        <el-card class="chart-card" shadow="hover">
          <RecoltesLineChart :data-quantite-collectee="dataQuantiteCollectee" />
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="Contrôles" name="controles">
        <el-card class="chart-card" shadow="hover">
          <ControlesBarChart />
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="Cultures" name="cultures">
        <el-card class="chart-card" shadow="hover">
          <CulturesPieChart />
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="Certification" name="certification">
        <el-card class="chart-card" shadow="hover">
          <CertificationAreaChart />
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="Répartition géo" name="repartition_geo">
        <el-card class="chart-card" shadow="hover">
          <RepartitionGeoChart />
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="Performance antennes" name="antennes">
        <el-card class="chart-card" shadow="hover">
          <AntennesRadarChart />
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import RecoltesLineChart from './RecoltesLineChart.vue';
import ControlesBarChart from './ControlesBarChart.vue';
import RepartitionGeoChart from './RepartitionGeoChart.vue';
import CulturesPieChart from './CulturesPieChart.vue';
import AntennesRadarChart from './AntennesRadarChart.vue';
import CertificationAreaChart from './CertificationAreaChart.vue';

export default {
  name: 'ChartsPanel',
  components: {
    RecoltesLineChart,
    ControlesBarChart,
    RepartitionGeoChart,
    CulturesPieChart,
    AntennesRadarChart,
    CertificationAreaChart,
  },
  props: {
    parcelles: {
      type: Array,
      default: () => [],
    },
    controleurs: {
      type: Array,
      default: () => [],
    },
    producteurs: {
      type: Array,
      default: () => [],
    },
    groupements: {
      type: Array,
      default: () => [],
    },
    unitesProductions: {
      type: Array,
      default: () => [],
    },
    audits: {
      type: Array,
      default: () => [],
    },
    controlesInternes: {
      type: Array,
      default: () => [],
    },
    formations: {
      type: Array,
      default: () => [],
    },
    cultures: {
      type: Array,
      default: () => [],
    },
    parcellesProduits: {
      type: Array,
      default: () => [],
    },
    parcellesProducteurs: {
      type: Array,
      default: () => [],
    },
    dataQuantiteCollectee: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeTab: 'recoltes',
    };
  },
  provide() {
    // Fournir les données aux composants enfants via inject de manière réactive
    // Utilisation d'une fonction provide avec getters pour assurer la réactivité dans Vue 2
    // Les composants enfants peuvent utiliser inject: ['dashboardData'] pour accéder à ces données
    const self = this;
    return {
      get dashboardData() {
        // Les getters garantissent que les valeurs sont toujours à jour
        return {
          parcelles: self.parcelles,
          controleurs: self.controleurs,
          producteurs: self.producteurs,
          groupements: self.groupements,
          unitesProductions: self.unitesProductions,
          audits: self.audits,
          controlesInternes: self.controlesInternes,
          formations: self.formations,
          cultures: self.cultures,
          parcellesProduits: self.parcellesProduits,
          parcellesProducteurs: self.parcellesProducteurs,
          dataQuantiteCollectee: self.dataQuantiteCollectee,
        };
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.charts-panel {
  padding: 20px;

  .chart-card {
    border-radius: 8px;
    border: 1px solid #e4e7ed;
    transition: all 0.3s ease;
    min-height: 500px;
    display: flex;
    flex-direction: column;

    ::v-deep .el-card__body {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 0;
      height: 100%;
    }

    &:hover {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
    }
  }
}
</style>

